module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Bliv ringet op\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("\n                    TAK\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi har nu modtaget din forespørgsel og vil ringe dig op hurtigst muligt.\n                ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe5f6abc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/contactSuccess.vue
// module id = 281
// module chunks = 1